import {
  fireFormStart,
  fireFormSubmitFail,
  fireFormSubmitSuccess
} from "./dtm";
import { actions as gtmActions, fireGtmEvent } from "./gtm";
import fireMboxConversion from "./target";

// Form events

export const formStarted = ({ name = "", numberOfFields = 0, type = "" }) => {
  fireGtmEvent(type, gtmActions.FORM_STARTED, numberOfFields);
  fireFormStart({ name, type });
};

export const formSubmitSuccess = ({ hashableIdentifier, name = "", pathName = "", type = "" }) => {
  fireGtmEvent(type, gtmActions.FORM_SUBMIT_SUCCESS, pathName);
  fireMboxConversion("[ExFormContactSalesSubmit]");
  fireFormSubmitSuccess({ hashableIdentifier, name, type });
};

export const formSubmitFail = ({
  invalidFieldNames = [],
  name = "",
  pathName = "",
  type = ""
}) => {
  fireGtmEvent(type, gtmActions.FORM_SUBMIT_FAIL, pathName);
  fireFormSubmitFail({ invalidFieldNames, name, type });
};

// Newsletter events

export const newsletterSubmitSuccess = ({ pathName = "" }) => {
  fireGtmEvent(
    "Subscribe to News or Events Form",
    gtmActions.FORM_SUBMIT_SUCCESS,
    pathName
  );
};



// WEBPACK FOOTER //
// ./js/analytics/index.js